import { useState } from "react";
import { Box, Divider, Tab, Tabs } from "@mui/material";
import { Typography } from "@platform/design-system";

import { TabLabel } from "../components";
import { MOCK_CARRIER_DETAILS } from "../mock";

import { CarrierDetailHeader } from "./CarrierDetailHeader";
import { CarrierRepsTab } from "./CarrierRepsTab";
import { CarrierRulesTab } from "./CarrierRulesTab";

import type { Carrier, CarrierDetailTab } from "../types";

interface CarrierDetailPanelProps {
  carrier: Carrier | null;
}

const CarrierDetailContent = ({
  carrier,
}: {
  carrier: Carrier;
}): React.JSX.Element => {
  const [activeTab, setActiveTab] = useState<CarrierDetailTab>("reps");

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <CarrierDetailHeader name={carrier.name} details={MOCK_CARRIER_DETAILS} />
      <Divider />
      <Tabs
        value={activeTab}
        onChange={(_, value: CarrierDetailTab) => setActiveTab(value)}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="Carrier detail tabs"
      >
        <Tab
          label={<TabLabel label="Reps" count={MOCK_CARRIER_DETAILS.reps} />}
          value="reps"
        />
        <Tab
          label={<TabLabel label="Rules" count={MOCK_CARRIER_DETAILS.rules} />}
          value="rules"
        />
      </Tabs>
      <Divider />
      <Box flex={1} overflow="auto" p={2}>
        {activeTab === "reps" && <CarrierRepsTab />}
        {activeTab === "rules" && <CarrierRulesTab />}
      </Box>
    </Box>
  );
};

export const CarrierDetailPanel = ({
  carrier,
}: CarrierDetailPanelProps): React.JSX.Element => (
  <Box
    height="100%"
    border={1}
    borderColor="divider"
    borderRadius={1}
    bgcolor="background.paper"
  >
    {carrier ? (
      <CarrierDetailContent key={carrier.id} carrier={carrier} />
    ) : (
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="body-medium" color="textSecondary">
          Pick a carrier on the left. Reps and rules for it show here.
        </Typography>
      </Box>
    )}
  </Box>
);
